export default __webpack_public_path__ + "static/Stables-brochure-f309cc806ae88d2143937bb0342afde4.jpg";